var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plat-student-account-info"},[_c('StudentLoginPanel',_vm._g(_vm._b({ref:"panel",on:{"start-refresh":_vm.startRefresh,"end-refresh":_vm.endRefresh}},'StudentLoginPanel',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }